import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { HeaderComponent } from "@components/header/header.component";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { IContent } from "~app/common/models/validationModel";
import { ErrorMediatorService } from "~app/common/services/error-mediator.service";
import { Viol3KontraktComponent } from "./viol3-kontrakt/viol3-kontrakt.component";
import { IViol3ArbetsorderAggregatPreviewData } from "./viol3-preview.model";
import { Viol3PreviewService } from "./viol3preview.service";

@Component({
    selector: "rask-viol3-preview",
    templateUrl: "./viol3-preview.component.html",
    styleUrls: ["./viol3-preview.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        CheckboxComponent,
        FormsModule,
        TabsComponent,
        TabComponent,
        Viol3KontraktComponent,
        HeaderComponent
    ]
})
export class Viol3PreviewComponent implements OnInit {
    dto: IViol3ArbetsorderAggregatPreviewData;
    visaUtkast = false;

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly validationService = inject(ErrorMediatorService);
    private readonly viol3PreviewService = inject(Viol3PreviewService);

    ngOnInit(): void {
        this.getData(true);
    }

    utkastChange(): void {
        this.getData();
    }

    private getData(firstrun = false) {
        const id = this.activatedRoute.snapshot.paramMap.get("id");
        this.viol3PreviewService.getViol3DataForArbetsorder(+id, this.visaUtkast).subscribe(x => {
            this.dto = x;
            if(!x.isActive && !this.visaUtkast && !firstrun) {
                const msg = {
                    message: "Aktivt kontrakt saknas, visar utkast istället.",
                    messageType: "ValidationMessage"
                } as IContent;
                this.validationService.add(msg);
            }
            this.visaUtkast = !x.isActive;
        });
    }
}
